module.exports = __webpack_public_path__ + "img/social-loading.2a406448.gif";